exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_video_v0AQSIpHC5hkF6qFI_2PH {\n  width: 100%;\n  float: left;\n  clear: both;\n  margin-bottom: 20px;\n}\n\n.IA_video_v0AQSIpHC5hkF6qFI_2PH iframe {\n  border: none;\n}\n\n.IA_iframeOverlay_270F2EBQF3x4x4D54Hn2r7 {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  position: relative;\n}\n\n.IA_dropZones_2RqQXa2OJ7F3159iDik_cG {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n  position: relative;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_video": "IA_video_v0AQSIpHC5hkF6qFI_2PH",
	"IA_iframeOverlay": "IA_iframeOverlay_270F2EBQF3x4x4D54Hn2r7",
	"IA_dropZones": "IA_dropZones_2RqQXa2OJ7F3159iDik_cG"
};